export default __webpack_public_path__ + "static/media/AQTimePro-Logo.9ab37464.svg";